/**
 * Exam choices and the count a student picks.
 *
 * The hardcoded subject list that used to live here is gone: its ids
 * ("chemistry", "use-of-english") matched nothing in the question bank, so a
 * subject picked from it could never have been saved. The picker reads
 * `GET /api/subjects` now.
 */
export type ExamChoice = "JAMB" | "WAEC";

/** JAMB is four subjects (English + 3), WAEC is unlimited. */
export const SUBJECTS_TO_PICK = 3;

/**
 * How many optional subjects to pick, by exam.
 *
 * JAMB: exactly 3 (+ English = 4 total, matching the UTME structure).
 * WAEC: unlimited — students sit as many subjects as they registered for,
 * which varies by school and candidate.
 */
export function subjectsToPickForExam(exam: ExamChoice | string | null | undefined): number | null {
  if (exam === "WAEC") return null; // unlimited
  return SUBJECTS_TO_PICK; // JAMB default: 3
}
